module.exports = __webpack_public_path__ + "static/media/new-sport-logo.dc8bb53e.png";